import { render, staticRenderFns } from "./studentCollect.vue?vue&type=template&id=1e927da2&scoped=true&"
import script from "./studentCollect.vue?vue&type=script&lang=js&"
export * from "./studentCollect.vue?vue&type=script&lang=js&"
import style0 from "./studentCollect.vue?vue&type=style&index=0&id=1e927da2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e927da2",
  null
  
)

export default component.exports